<template>
  <div
    v-if="appendToBody === false || had === 0"
    class="pricelistbox"
    :class="type === 'reverse' ? 'reverse' : ''"
  >
    <ul class="pricelist" ref="pricelist" @click.prevent.stop="clickpricelist">
      <li
        v-if="this.$store.state.rates[this.$store.state.currentcountry]"
        style="text-transform: capitalize"
      >
        <div></div>
        <span>Auto</span>
      </li>
      <li v-if="this.$store.state.rates.AUD">
        <div></div>
        <span :class="this.$store.state.pricetype == 'AUD' ? 'bold' : ''"
          >AUD</span
        >
      </li>
      <li v-if="this.$store.state.rates.CAD">
        <div></div>
        <span :class="this.$store.state.pricetype == 'CAD' ? 'bold' : ''"
          >CAD</span
        >
      </li>
      <li v-if="this.$store.state.rates.CNY">
        <div></div>
        <span :class="this.$store.state.pricetype == 'CNY' ? 'bold' : ''"
          >CNY</span
        >
      </li>
      <li v-if="this.$store.state.rates.EUR">
        <div></div>
        <span :class="this.$store.state.pricetype == 'EUR' ? 'bold' : ''"
          >EUR</span
        >
      </li>
      <li v-if="this.$store.state.rates.GBP">
        <div></div>
        <span :class="this.$store.state.pricetype == 'GBP' ? 'bold' : ''"
          >GBP</span
        >
      </li>
      <li v-if="this.$store.state.rates.JPY">
        <div></div>
        <span :class="this.$store.state.pricetype == 'JPY' ? 'bold' : ''"
          >JPY</span
        >
      </li>
      <li v-if="this.$store.state.rates.NZD">
        <div></div>
        <span :class="this.$store.state.pricetype == 'NZD' ? 'bold' : ''"
          >NZD</span
        >
      </li>
      <li v-if="this.$store.state.rates.USD">
        <div></div>
        <span :class="this.$store.state.pricetype == 'USD' ? 'bold' : ''"
          >USD</span
        >
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  props: {
    type: {
      type: [String],
    },
    appendToBody: {
      type: [Boolean],
    },
  },
  data() {
    return {
      had: 0,
    };
  },
  methods: {
    clickpricelist(e) {
      if (e.target.parentNode.tagName == "LI") {
        // 判断如果是auto的话 存入自动获取的当前国家
        var pricetype =
          e.target.parentNode.lastChild.innerText == "Auto"
            ? this.$store.state.currentcountry
            : e.target.parentNode.lastChild.innerText;
        this.$(".pricelist").css("display", "none");
        localStorage.setItem("pricetype", pricetype);
        this.$store.dispatch("changepricetype", pricetype);
      } else if (e.target.tagName == "LI") {
        var pricetype =
          e.target.lastChild.innerText == "Auto"
            ? this.$store.state.currentcountry
            : e.target.lastChild.innerText;
        this.$(".pricelist").css("display", "none");
        localStorage.setItem("pricetype", pricetype);
        this.$store.dispatch("changepricetype", pricetype);
      }
    },
  },
  mounted() {
    this.had=this.$('body>.pricelistbox').length;
    if (this.appendToBody !== false) {
      document.body.appendChild(this.$el);
    }
  },
};
</script>
<style scoped lang='scss'>
.reverse {
  transform: rotateX(180deg);
  transform-origin: center -17px;
  li {
    transform: rotateX(180deg);
  }
}
.pricelistbox {
  width: 80px;
  position: absolute;
  .pricelist {
    border: 1px solid rgb(240, 240, 240);
    padding: 2px;
    position: absolute;
    background: white;
    display: none;
    z-index: 99999;
    top: 1px;
    left: 0;

    li {
      font-size: 13px;
      text-align: left;
      padding: 2px;
      color: black;
      border-bottom: 1px solid #d8d8d8;
      list-style: none;
      cursor: pointer;
      div {
        background-image: url("/images/sprite222.png");
        background-size: 352px 330px;
        width: 22px;
        height: 22px;
        max-width: 22px;
        max-height: 22px;
        min-width: 22px;
        min-height: 22px;
        display: inline-block;
        padding: 0;
        margin: 0 2px 0 0;
        border: 0;
        background-color: transparent;
        vertical-align: middle;
        opacity: 1;
      }
      .bold {
        font-weight: bold !important;
      }
      span {
        vertical-align: middle;
        padding-right: 5px;
        font-weight: normal !important;
      }
    }

    li:nth-child(1) {
      padding-top: 0;
      div {
        background-position: 0px -221px;
      }
    }

    li:nth-child(2) {
      div {
        background-position: -176px -1px;
      }
    }

    li:nth-child(3) {
      div {
        background-position: -88px -45px;
      }
    }

    li:nth-child(4) {
      div {
        background-position: -242px -45px;
      }
    }

    li:nth-child(5) {
      div {
        background-position: -44px -89px;
      }
    }

    li:nth-child(6) {
      div {
        background-position: -198px -89px;
      }
    }

    li:nth-child(7) {
      div {
        background-position: -88px -133px;
      }
    }

    li:nth-child(8) {
      div {
        background-position: -88px -199px;
      }
    }

    li:nth-child(9) {
      border: none;
      div {
        background-position: -88px -265px;
      }
    }

    li:hover {
      background: rgb(51, 51, 51);
      color: white;
    }
  }
}
</style>